import {
  Form,
  SelectInput,
  TextAreaInput,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { StyledRateInput } from 'src/pages/vacancies/sub-pages/vacancy-details/components/styled-rate-input';

import { FeedbackElementWrapper, FeedbackWrapper } from './applicant-feedbacks-form-list.styles';

const ApplicantFeedbacksFormList = ({ responsiblePersons }: { responsiblePersons: any[] }) => {
  const { t } = useTranslation(['common', 'vacancies']);

  return (
    <Form.List name="feedbacks">
      {fields => (
        <FeedbackWrapper>
          <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
            {t('employee:employeeInterview.labels.feedback')}:
          </Typography>
          {fields.map(field => (
            <FeedbackElementWrapper key={field.key}>
              <Form.Item
                name={[field.name, 'feedbackFrom']}
                label={t('vacancies:labels.feedbackFrom')}
                rules={[{ required: true }]}
              >
                <SelectInput disabled showArrow={false}>
                  {responsiblePersons.map((item: any) => (
                    <SelectInput.Option key={item._id} value={item._id}>
                      {item.profile.displayName}
                    </SelectInput.Option>
                  ))}
                </SelectInput>
              </Form.Item>
              <Form.Item name={[field.name, 'rating']} label={t('vacancies:labels.rating')}>
                <StyledRateInput />
              </Form.Item>
              <Form.Item
                name={[field.name, 'feedback']}
                label={t('employee:employeeInterview.labels.feedback')}
              >
                <TextAreaInput
                  placeholder={t('vacancies:labels.writeYourFeedback')}
                  showCount
                  maxLength={3000}
                />
              </Form.Item>
            </FeedbackElementWrapper>
          ))}
        </FeedbackWrapper>
      )}
    </Form.List>
  );
};

export default ApplicantFeedbacksFormList;
